import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { InfoBar } from './components/InfoBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'pl';
    document.title = 'JUDO GOTOWE™ – Cały sezon judo dla dzieci gotowy dla trenera';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3ii4sg33z0up3">
      <div lang="pl" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3mkrbpfmkt7ao">
        <InfoBar data-id="element-2" data-mp="3rbrbqtqzs5he" />
        <main data-id="element-3" data-mp="3rdar8i4tqci4">
          <Hero data-id="element-4" data-mp="3rcsyvwla8ifh" />
          <StatsBar data-id="element-5" data-mp="3recdzjv7cnfo" />
          <Difference data-id="element-6" data-mp="5yi8qe3h5da" />
          <Recognize data-id="element-7" data-mp="67z9oh5w26u" />
          <WhatsInside data-id="element-8" data-mp="4n5w26l2pak" />
          <InsidePages data-id="element-9" data-mp="82lr78302d1" />
          <Bonuses data-id="element-10" data-mp="2zl3c5m4yv85u" />
          <HowItWorks data-id="element-11" data-mp="2zlli5ahfl0qy" />
          <Audience data-id="element-12" data-mp="2zmeoiach9o8k" />
          <Offer data-id="element-13" data-mp="2zmwhmy3ufmc9" />
          <Guarantee data-id="element-14" data-mp="2zng2amkvootz" />
          <Faq data-id="element-15" data-mp="33m5be2yvvk7t" />
          <FinalCta data-id="element-16" data-mp="33lx0uhq8gqzs" />
        </main>
        <Footer data-id="element-17" data-mp="33mykvbp88ntn" />
      </div>
    </MotionConfig>;
}